import React, { useEffect, useState } from "react";

const ProgressBars = () => {
  const progressData = [
    {
      title: "Restorative Dentistry",
      percent: 98,
    },
    {
      title: "Periodontal (Gum)",
      percent: 99,
    },
  ];

  const [animatedProgress, setAnimatedProgress] = useState(
    progressData.map(() => 0)
  );

  // 🎨 Dynamic color function
  const getColor = (percent) => {
    if (percent === 98) return "hsl(21.82deg 87.61% 55.69%)"; // blue (example)
    if (percent === 99) return "#b2442c"; // required color
    return "#999"; // fallback
  };

  useEffect(() => {
    const timers = progressData.map((item, index) =>
      setTimeout(() => {
        setAnimatedProgress((prev) => {
          const updated = [...prev];
          updated[index] = item.percent;
          return updated;
        });
      }, index * 300)
    );

    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="bg-progress">
      {progressData.map((item, index) => (
        <div
          className="progress-bar"
          key={index}
          style={{ marginBottom: "20px" }}
        >
          <label className="progress-label">
            {item.title}
            <span style={{ color: getColor(item.percent) }}>
              {animatedProgress[index]}%
            </span>
          </label>

          <div className="progress">
            <div
              className="progress-inner"
              style={{
                width: `${animatedProgress[index]}%`,
                backgroundColor: getColor(item.percent),
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgressBars;
